import React, { useEffect, useState } from "react";
import { Button, Col } from "reactstrap";
import { formatDate, remainingSeconds } from "../../../Utils/externalFunctions";
import useAxios from "../../../Utils/useAxios";
import { Link } from "react-router-dom";
import CollapseableCard from "../../../CommonElements/Collapse/CollapseableCard";
import LoadingContainer from "../../../CommonElements/Loading";
import getSystemLogs from "../services/getSystemLogs";

const getTimeCreated = (date) => {
  let remTime = remainingSeconds(date) * -1;
  const listTimeCreated = getListTimeCreated(remTime);
  let timeType = "seconds";
  let timeIdx = 0;

  if (listTimeCreated[3] > 0) {
    timeIdx = 3;
    timeType = "days";
  } else if (listTimeCreated[2] > 0) {
    timeIdx = 2;
    timeType = "hours";
  }

  return `${timeIdx == 0 ? `${listTimeCreated[1]} minutes` : ""} ${
    listTimeCreated[timeIdx]
  } ${timeType} ago`;
};

const getListTimeCreated = (
  remTime,
  idx = 0,
  listTime = [],
  listRem = [60, 60, 24]
) => {
  if (idx >= 3) {
    listTime.push(remTime);
    return listTime;
  }

  listTime.push(remTime % listRem[idx]);

  return getListTimeCreated(
    parseInt(remTime / listRem[idx]),
    idx + 1,
    listTime
  );
};

const RecentActivity = (props) => {
  const axiosInstance = useAxios();

  const [systemLogs, setSystemLogs] = useState([]);
  const [isPending, setIsPending] = useState(false);

  let isMounted = true;
  useEffect(() => {
    refreshSystemLogs();

    return () => {
      isMounted = false;
    };
  }, []);

  
  const refreshSystemLogs = async () => {
    setIsPending(true);
    getSystemLogs(axiosInstance).then((response) => {
      if (response.status === 200 && isMounted) {
        setIsPending(false);
        setSystemLogs(response.data?.slice(0, 5));
      } else {
        setIsPending(false);
        console.error("Error when fetching data");
      }
    })
  };

  return (
    <Col {...props}>
      <CollapseableCard title={"Recent Activity"}>
        <LoadingContainer isPending={isPending}>
          <>
            <div className="col">
              {systemLogs?.map((item) => (
                <RecentActivityRow row={item} />
              ))}
            </div>
            {systemLogs?.length > 0 && (
              <div className="row pt-3">
                <div className="col">
                  {formatDate(systemLogs[0].date_modified)}
                </div>
                <div className="col-8">
                  {getTimeCreated(systemLogs[0].date_modified)}
                </div>
              </div>
            )}
          </>
        </LoadingContainer>

        <div className="d-flex pt-4 justify-content-center">
          <Link to={`${process.env.PUBLIC_URL}/system-log`}>
            <Button className="rounded">Lihat System Log</Button>
          </Link>
        </div>
      </CollapseableCard>
    </Col>
  );
};

const RecentActivityRow = ({ row }) => {
  return (
    <div className="row p-2 py-3 border-top border-bottom">
      <div className="col-1 d-flex justify-content-center align-items-center">
        <h4>{Array.from(row.username?.toUpperCase())[0]}</h4>
      </div>
      <div className="col d-grid gap-2">
        <div className="col text-justify">{row.action}</div>
        <div className="row">
          <div className="col">{formatDate(row.date_modified)}</div>
          <div className="col-8">{getTimeCreated(row.date_modified)}</div>
        </div>
      </div>
    </div>
  );
};

export default RecentActivity;
